<template>
    <div>
        <Scroll :height="height * 0.75">
            <h2 style="padding-top: 10px;">设备参数下发</h2>
            <Spin fix v-show="isSpinShow">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Form ref="formInsert" :label-width="180">
                <FormItem :label="item.cnName" v-for="item in formInsert" v-if="isShowParam(item.name)">
                    <Row span=24 v-if="item.dataType != 'bool'">
                        <Col span=10>
                        <Tooltip :content="item.tip" :max-width="200" placement="top" style="width: 100%" transfer>
                            <Input type="number" :max="item.max" :min="item.min" v-model="item.default" style="width: 100%;"></Input>
                        </Tooltip>
                        </Col>
                        <Col span=4>
                        <p style="text-align: center;">{{item.unit}}</p>
                        </Col>
                    </Row>
                    <Row span=24 v-if="item.dataType == 'bool'" >
                        <Col span=10>
                        <Tooltip :content="item.tip" :max-width="200" placement="top" style="width: 100%" transfer>
                            <Select v-model="item.default">
                                <Option value="true">是</Option>
                                <Option value="false">否</Option>
                            </Select>
                        </Tooltip>
                        </Col>
                        <Col span=4>
                        <p style="text-align: center;">{{item.unit}}</p>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
            <Button type="primary" size="large" long :loading="isLoadingButton" @click="downInstructionData">下发</Button>
        </Scroll>
        <Scroll :height="height * 0.25 - 50" style="background-image: url(c2.jpg);backgroundSize: 100% 90%;">
        </Scroll>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isSpinShow: false,
                isLoadingButton: false,
                height: window.innerHeight,
                placement: 'right',
                formInsert: [],
                meterId: "",
                commandType: "0x11"
            }
        },
        mounted() {
            //this.getDownInstruction();
        },
        methods: {
            isShowParam(param) {
                if (["overPressureThreshold", "underPressureThreshold", "velocityLowerLimit", "constantFlowUpperLimit",
                        "temperatureThreshold", "noDisturbStartHour", "noDisturbEndHour", "regularCheckDay",
                        "regularCheckHour"
                    ].indexOf(param) != -1) {
                    return true;
                } else {
                    return false;
                }
            },
            getDownInstruction(param) {
                let that = this;
                that.meterId = param;
                that.isSpinShow = true;
                $.ajax({
                    url: "/api/instructions/downInstruction",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        commandDeviceId: that.meterId,
                        commandType: "0x11"
                    }),
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.errorCode == 0) {
                            that.formInsert = receiveData.body;
                            that.formInsert.map(item => {
                                if (item.dataType == 'bool') {
                                    item.default = (item.default || false).toString();
                                }
                            });
                        } else {
                            that.$Notice.error({
                                title: "异常",
                                desc: receiveData.errorInfo
                            });
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isSpinShow = false;
                    }
                });
            },
            downInstructionData() {
                let that = this;
                let downData = {
                    command: {
                        paras: {

                        }
                    },
                    commandType: "0x11",
                    deviceId: that.meterId
                };
                that.formInsert.map(item => {
                    if (item.dataType == 'bool') {
                        downData.command.paras[item.name] = JSON.parse(item.default);
                    } else {
                        downData.command.paras[item.name] = item.default * 1;
                    }
                });
                console.log(downData);
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/instructions/downInstructionData",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify(downData),
                    dataType: "json",
                    success: function(receiveData) {
                        if (receiveData.errorCode == 0) {
                            that.$Notice.success({
                                title: "成功",
                                desc: "参数下发成功"
                            });
                        } else {
                            that.$Notice.error({
                                title: "异常",
                                desc: receiveData.errorInfo
                            });
                        }
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function() {
                        that.isLoadingButton = false;
                    }
                });
            }
        }
    }
</script>

<style>
</style>
